<div class="license-card" [class]="{'expanded': isExpanded,'prio-subscription': isPriorityLicense}">
  <div class="card-header" (click)="toggleExpand()">
    <div class="package-info">
      <div class="package-number">{{ packageNumber }}</div>
      <div class="date-range">{{ startDate | date:'dd. MMM yyyy' }} - {{ endDate | date:'dd. MMM yyyy' }}</div>
    </div>

    <div class="progress-container">
      <div class="progress-pill">
        <div class="progress-used" [style.width.%]="usedPercentage"></div>
        <div class="progress-text">
          <span>{{ licensesUsed }} / {{ licensesTotal }} Verwendete Lizenzen</span>
        </div>
      </div>
    </div>

    <div class="expand-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline *ngIf="!isExpanded" points="6 9 12 15 18 9"></polyline>
        <polyline *ngIf="isExpanded" points="18 15 12 9 6 15"></polyline>
      </svg>
    </div>
  </div>

  <div class="card-body" *ngIf="isExpanded">
    <div class="card-content">

      <div class="features-section">
        <h3>Features</h3>
        <ul class="features-list">
          <li *ngFor="let feature of features">{{ feature }}</li>
        </ul>
      </div>

      <div class="price-section">
        <div class="price">{{ price.toFixed(2) }} €</div>
      </div>

    </div>
    <div class="action-buttons">
      <button *ngIf="admin && !isPriorityLicense && !subscription.canceled" style="width: 150px; justify-self: right"
         matButton="elevated" color="warn"
        (click)="manageSubscription(packageId)">
        Kündigen
      </button>
      <button *ngIf="admin && !isPriorityLicense && subscription.canceled" style="width: 150px; justify-self: right"
         matButton="elevated" class="green-confirm"
        (click)="manageSubscription(packageId)">
        Abo fortsetzten
      </button>
      <button *ngIf="admin" style="
                        width: 150px;
                        justify-self: left;
                        margin-right: 1rem;
                    " matButton="elevated" class="green-confirm" type="submit" (click)="onUserAction()">
        Verwalten
      </button>

    </div>
  </div>
</div>